<template>
  <div class="el-container">
    <CellProductionLine v-if="$route.params.type == 'cellProductionLine'" />
    <CompanyProfile v-if="$route.params.type == 'companyProfile'" />
    <CorporateCulture v-if="$route.params.type == 'corporateCulture'" />
    <ProductionOffice v-if="$route.params.type == 'productionOffice'" />
    <News v-if="$route.params.type == 'news'" />
  </div>
</template>

<script>
import CellProductionLine from './about/CellProductionLine'
import CompanyProfile from './about/CompanyProfile'
import CorporateCulture from './about/CorporateCulture'
import ProductionOffice from './about/ProductionOffice'
import News from './News'
export default {
  name: 'About',
  components: {
    CellProductionLine,
    CompanyProfile,
    CorporateCulture,
    ProductionOffice,
    News
  },
  data: () => {
    return {

    }
  },
  mounted() {
    this.$route.params.type == 'companyProfile' && this.$emit('checkBanner', !0)
  },
  methods: {

  }

}
</script>

<style scoped lang="scss">
</style>
